const vars = {
  env: import.meta.env.MODE,
  console: (import.meta.env.VITE_APP_ENABLE_CONSOLE === 'true'),
  mocks: (import.meta.env.VITE_APP_ENABLE_MOCKS === 'true'),
  maxFileSize: import.meta.env.VITE_APP_MAX_FILE_SIZE,
  sentryDsn: import.meta.env.REACT_APP_SENTRY_DSN,
  request: {
    sseUrl: import.meta.env.VITE_APP_SSE_REQUEST,
    baseURL: import.meta.env.VITE_APP_REQUEST_BASEURL,
    timeout: import.meta.env.VITE_APP_REQUEST_TIMEOUT,
  },
};

export default vars;
